module.exports = __webpack_public_path__ + "img/qna_tell.09c05e0.png";